import React, { useEffect } from "react";
import Navbar from "./components/Navbar";
import YourPersonalTripPlanner from "./components/YourPersonalTripPlanner";
import useTranslate from "../../hooks/useTranslate";
import { useNumberCounter } from "./useNumberCounter";
import { useWhenVisible } from "./useWhenVisible";
import { useParams } from "react-router-dom";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { LANDING } from "../../constants/ROUTER_PATH_TITLE";
import FeaturedDestinations from "./components/FeaturedDestinations";
import FeaturedItineraries from "./components/FeaturedItineraries";
import HowItWorks from "./components/HowItWorks";
import Footer from "./components/Footer";

const counterSecond = 2;
const counterTimes = 20;
const ValaiLanding = () => {
    const { language } = useParams();
    const formattedLanguage = language
        ? language.toUpperCase() === "PT-BR"
            ? "pt-BR"
            : language.split("-")[0].toLowerCase()
        : undefined;

    const { t, onSelectedLangCode } = useTranslate();

    useEffect(() => {
        const langCodeKeys: string[] = window.tconfig.T.langCodes.map(l => l.value);

        if (formattedLanguage && langCodeKeys.includes(formattedLanguage)) {
            onSelectedLangCode(formattedLanguage);
        }
    }, [formattedLanguage, onSelectedLangCode]);

    const { count: countriesCount, runCounter: runCountriesCounter } =
        useNumberCounter(65, counterSecond, counterTimes);
    const { count: citiesCount, runCounter: runCitiesCounter } = useNumberCounter(
        550,
        counterSecond,
        counterTimes
    );
    const { refDom } = useWhenVisible(() => {
        runCountriesCounter();
        runCitiesCounter();
    });

    const { getLocalData } = useLocalStorage<"light" | "dark">("theme");
    const theme = getLocalData();

    document.title = LANDING.TITLE(t("welcome"));

    return (
        <>
            {window.tconfig.LANDING_PAGE_URL ? (
                <iframe
                    className="w-full h-full"
                    src={window.tconfig.LANDING_PAGE_URL}
                    title={window.tconfig.BRAND_NAME}
                ></iframe>
            ) : (
                <div className="min-h-screen font-geist text-[#0B1215]">
                    <Navbar
                        theme={theme}
                        t={t}
                    />
                    <main>
                        <YourPersonalTripPlanner
                        />
                        <FeaturedItineraries />
                        <HowItWorks t={t} />
                        <FeaturedDestinations />
                        <Footer t={t} />
                    </main>
                </div>
            )}
        </>
    );
};

export default ValaiLanding;

